import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "./ui/dialog";
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";
import { Star, MessageSquarePlus } from "lucide-react";
import { toast } from "sonner";
import { api, apiErr } from "../lib/api";

export default function FeedbackDialog() {
  const [open, setOpen] = useState(false);
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [sending, setSending] = useState(false);

  const submit = async () => {
    if (!rating) return toast.error("Please pick a rating");
    setSending(true);
    try {
      await api.post("/feedback", { rating, comment });
      toast.success("Thanks for the feedback!");
      setOpen(false); setRating(0); setComment("");
    } catch (e) {
      toast.error(apiErr(e));
    } finally { setSending(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button
          data-testid="open-feedback-btn"
          className="brut-btn rounded-full bg-[#FFB3BA] text-black hover:bg-[#FFB3BA] fixed bottom-6 right-6 z-40"
        >
          <MessageSquarePlus size={16} className="mr-2" strokeWidth={2.5} />
          Rate Us
        </Button>
      </DialogTrigger>
      <DialogContent className="brut-border brut-shadow bg-white rounded-none">
        <DialogHeader>
          <DialogTitle className="font-black text-2xl">Rate ScienceLab</DialogTitle>
          <DialogDescription>Share your rating and any feedback with us — it helps us improve.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="flex gap-2 justify-center py-4">
            {[1, 2, 3, 4, 5].map((n) => (
              <button
                key={n}
                data-testid={`star-${n}`}
                onClick={() => setRating(n)}
                className="transition-transform hover:scale-110"
              >
                <Star
                  size={40}
                  strokeWidth={2.5}
                  fill={n <= rating ? "#FFD700" : "none"}
                  color={n <= rating ? "#1A1A1A" : "#1A1A1A"}
                />
              </button>
            ))}
          </div>
          <Textarea
            data-testid="feedback-comment"
            placeholder="Tell us what you love or what we can improve…"
            value={comment}
            maxLength={1000}
            onChange={(e) => setComment(e.target.value)}
            className="brut-input rounded-none min-h-[100px]"
          />
          <Button
            data-testid="submit-feedback-btn"
            onClick={submit}
            disabled={sending}
            className="brut-btn rounded-none w-full bg-[#1A1A1A] text-white hover:bg-[#1A1A1A]"
          >
            {sending ? "Sending…" : "Submit Feedback"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
